import {
  HeimdallWidget,
  GlobeVisualization,
  SwathManager,
  SwathTimeController,
  SatelliteManager,
  TimeOverlay,
  ButtonOverlay,
  constants
} from 'heimdall';

const $ = require('jquery');
window.$ = window.jQuery = $;

window.onload = (event) => {

  let hw = new HeimdallWidget({
    widgetID: 'heimdall-widget',
    startTime: new Date(0)});
  let gv = new GlobeVisualization({widget: hw});
  let bo = new ButtonOverlay({widget: hw, showDatasource: true});
  new TimeOverlay(hw);
  hw.gv = gv;
  window.heimdallWidget = hw;

  titleDiv = document.createElement("div");
  titleDiv.style = "position:absolute;font-size:24pt;font-family:Segoe UI Symbol;border-radius:8pt;background-color:rgba(50, 50, 50, 0.6);color:lavender;top:15pt;left:20pt;padding:10pt;display:none;"
  hw.DOMElement.appendChild(titleDiv);

  function updateSource(source){

    hw.sm.datafilePath = source.datafiles;
    hw.sm.loadDatabase(source.db, function(){hw.stc.replay();});
    if('rate' in source){
      hw.config.timeRate = source.rate;
    } else {
      hw.config.timeRate = HeimdallWidget.defaultConfig.timeRate;
    }
    hw.stc.leadLagTime = hw.config.timeRate * 3 * constants.ONE_MINUTE / 200;
    hw.satm.clear();
    if('tles' in source){
      hw.satm.loadSat(source.tles);
    }
    if('followSatellite' in source){
      hw.satm.setFollowSatellite(source.followSatellite);
    } else {
      hw.satm.setFollowSatellite(-1);
    }

    hw.unpause();

  }

  // Load datasources
  fetch('/static/db/swath-sources.json').then(r => r.json()).then(j => {

    hw.datasources = j;
    hw.selectedSource = 0;

    let source = hw.datasources[hw.selectedSource];

    let sm = new SwathManager({
      world: gv.world,
      datafilePath: source.datafiles,
      dbFile: source.db,
    });
    let stc = new SwathTimeController(
      hw,
      sm,
      true,
      true,
      constants.TWENTYFOUR_HOURS);
    let satm = new SatelliteManager(
      hw,
      gv,
      source.tles,
      followSatelite = source.followSatellite);
    hw.sm = sm;
    hw.stc = stc;
    hw.satm = satm;

    stc.newSwathCallback = function(newSwath){
      if(newSwath.name){
        if(newSwath.name != titleDiv.innerHTML){
          $(titleDiv).fadeOut(1500, function(){titleDiv.innerHTML=newSwath.name;}).fadeIn(1500);
        }
      } else {
        $(titleDiv).fadeOut(1500);
      }
    }

    let sourceul = document.createElement("ul");
    sourceul.style = "display:none;float:right;padding:10px;width:max-content;border-radius:8pt;background:#c8c8c833;position:absolute;direction:ltr;list-style:none;";
    for(i in hw.datasources){
      const source = hw.datasources[i];
      let sourceli = document.createElement("li");
      sourceli.innerHTML = source.name;
      $(sourceli).click(function(){
        updateSource(source);
      })
      sourceul.appendChild(sourceli);
    }
    
    $(bo.datasourceSpan).click(function () {
      $(this).find('ul').slideToggle('medium');
    });
    bo.datasourceSpan.appendChild(sourceul);

  });

};